import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../app/store";
import { initiateJoinByContactIdAction } from "../../slices/getStartedSlice";
import Loader from "../../../../components/Loader";

const InitiateJoin: React.FC = () => {
  const { hubspotContactId } = useParams<{ hubspotContactId: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!hubspotContactId) {
      navigate("/registration/get-started");
      return;
    }

    dispatch(
      initiateJoinByContactIdAction(hubspotContactId, () => {
        navigate("/registration/student-details");
      }),
    );
  }, [hubspotContactId, dispatch, navigate]);

  return <Loader />;
};

export default InitiateJoin;
